import React, { useEffect, useState } from "react";
import { GoArrowLeft } from "react-icons/go";

import { useLocation, useNavigate, useParams } from "react-router-dom";
import { FiEdit, FiPrinter, FiDownload } from "react-icons/fi";
import { MdDelete } from "react-icons/md";

import PatientsDoctorTab from "./PatientsDoctorTab";
import { useLazyGetpatientQuery } from "../../../State/Api/AddpatientApiSlice";


function PatientsOverview() {

    const navigate = useNavigate();
     const location = useLocation();
    const [isOpen, setIsOpen] = useState(false);

     const query = new URLSearchParams(location.search);
  const from = query.get("from"); 

    const handleBack = () => {
    if (from) {
      navigate(from);
    } else {
   
      navigate(-1);
    }
  };

    
const { id: patientId } = useParams();
  
    const [fetchPatientView, { data: patientOverviewData }] =
      useLazyGetpatientQuery();

    
  
    useEffect(() => {
      if (patientId) {
        fetchPatientView(patientId);
      }
    }, [patientId]);

      const basicInfo = patientOverviewData?.basicInfo || {};
  const medicalInfo = patientOverviewData?.medicalinfo || {};
  const admissionInfo = patientOverviewData?.admissionvisitinfo || {};

  const patientDetails = `

  `

  return (
    <>
    <style>{patientDetails}</style>
      <div className="flex flex-col gap-3">
        <div className="flex items-center gap-4 flex-wrap">
          <button
            onClick={handleBack}
            className="bg-[#fff] inline-flex items-center justify-center shrink-0 gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 border border-input bg-background hover:bg-accent hover:text-accent-foreground size-10"
          >
            <GoArrowLeft />
            <span className="sr-only">Back</span>
          </button>
          <div>
            <h1 className="text-2xl lg:text-3xl font-bold tracking-tight mb-2">
              Patient Details
            </h1>
            {/* <p className="text-muted-foreground">
              View and manage patient information.
            </p> */}
          </div>
        </div>

        <div className="flex flex-col lg:flex-row gap-5 min-h-full items-stretch">
          <div className="rounded-lg  bg-card text-card-foreground lg:w-1/3 h-full">
          <div className="border bg-white rounded-lg shadow-sm" >
            <div className="flex flex-col space-y-1.5 p-3 md:p-4 xxl:p-6 pb-2">
              <div className="flex justify-end items-start">
   {/* <div className="relative">
     
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className="inline-flex items-center justify-center shrink-0 gap-2 rounded-md text-sm font-medium ring-offset-background transition-colors hover:bg-gray-100 hover:text-black w-10 h-10"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="lucide lucide-ellipsis h-4 w-4"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          viewBox="0 0 24 24"
        >
          <circle cx="12" cy="12" r="1" />
          <circle cx="19" cy="12" r="1" />
          <circle cx="5" cy="12" r="1" />
        </svg>
        <span className="sr-only">Actions</span>
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-1 w-20 bg-white border border-gray-200 rounded-lg">
          <button
            className="block w-full text-left px-4 py-2 text-sm hover:bg-gray-100"
            onClick={() => {
              navigate("/PatientsAdd", {
            state: { id: basicInfo?.useruniqueid },
          });
              setIsOpen(false);
            }}
          >
            Edit
          </button>
        </div>
      )}
    </div> */}
</div>
            </div>

            <div className="p-3 md:p-4 xxl:p-6 space-y-6">
              <div className="flex flex-col items-center text-center">
                <span className="relative flex shrink-0 overflow-hidden rounded-lg h-24 w-24 mb-2">
                  <img
                    className="aspect-square h-full w-full"
                    alt={basicInfo?.fullname}
                    src={
                      basicInfo?.gender?.charAt(0).toUpperCase() +
                        basicInfo?.gender?.slice(1) ===
                      "Male"
                        ? "https://img.freepik.com/free-vector/businessman-character-avatar-isolated_24877-60111.jpg?semt=ais_hybrid&w=740&q=80"
                        : "https://static.vecteezy.com/system/resources/previews/004/758/368/non_2x/female-user-illustration-on-a-transparent-background-premium-quality-symbols-flat-icon-for-concept-and-graphic-design-vector.jpg"
                    }
                  />
                </span>
                <h2 className="text-xl font-bold">
                  {basicInfo?.fullname || "-"}
                </h2>
                <div className="text-sm text-muted-foreground">
                {basicInfo?.patientiduniqueid || "-"}
              </div>
                <p className="text-muted-foreground">
                  {basicInfo?.age || "-"} years •{" "}
                  {basicInfo?.gender?.charAt(0).toUpperCase() +
                    basicInfo?.gender?.slice(1) || "-"}
                </p>
                <div className="flex items-center gap-2 mt-2">
                  <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold text-white bg-green-500">
                    {basicInfo?.isactive ? "Active" : "Inactive"}
                  </div>
                  <div className="inline-flex items-center rounded-full border border-blue-500 text-blue-500 px-2.5 py-0.5 text-xs font-semibold">
                    {medicalInfo?.bloodGroup || "-"}
                  </div>
                </div>
              </div>
              </div>
              </div>

              <div className="shrink-0 bg-border h-[1px] w-full"></div>
              <div className="border bg-white shadow-sm rounded-lg flex flex-col space-y-1.5 p-3 md:p-4 xxl:p-6 pb-2 mt-4">
              <div className="space-y-4">
                {/* Personal Information */}
                <div className="flex items-start gap-3">
                  <svg
                    className="h-5 w-5 text-blue-600"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    viewBox="0 0 24 24"
                  >
                    <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
                    <circle cx="12" cy="7" r="4" />
                  </svg>
                  <div className="space-y-1.5">
                    <h3 className="text-base font-semibold text-gray-800 text-decoration-underline">
                      Personal Information
                    </h3>
                    <p style={{ fontSize: "14px" }}>
                      <strong>Date of Birth:</strong>{" "}
                      {basicInfo?.dateofbirth
                        ? new Date(basicInfo.dateofbirth)
                            .toLocaleDateString("en-GB", {
                              day: "2-digit",
                              month: "short",
                              year: "numeric",
                            })
                            .replace(/ /g, "-")
                        : "-"}
                    </p>
                    <p style={{ fontSize: "14px" }}>
                      <strong>Phone:</strong> {basicInfo?.contactnumber || "-"}
                    </p>
                    <p style={{ fontSize: "14px" }}>
                      <strong>Email:</strong> {basicInfo?.emailaddress || "-"}
                    </p>
                    <p style={{ fontSize: "14px" }}>
                      <strong>Address:</strong> {basicInfo?.address || "-"}
                    </p>
                  </div>
                </div>
                <hr></hr>

                {/* Medical Info */}
                <div className="flex items-start gap-3">
                  <svg
                    className="h-5 w-5 text-green-600"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    viewBox="0 0 24 24"
                  >
                    <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" />
                    <path d="M14 2v4a2 2 0 0 0 2 2h4" />
                    <path d="M10 9H8" />
                    <path d="M16 13H8" />
                    <path d="M16 17H8" />
                  </svg>
                  <div>
                    <h3 className="text-base font-semibold text-gray-800 text-decoration-underline mb-2">
                      Medical Information
                    </h3>
                    <div className="text-sm space-y-1.5">
                      <p style={{ fontSize: "14px" }}>
                        <strong>Blood Type:</strong>{" "}
                        {medicalInfo?.bloodGroup || "-"}
                      </p>
                      <p style={{ fontSize: "14px" }}>
                        <strong>Allergies:</strong>{" "}
                        {medicalInfo?.allergies_ifany || "-"}
                      </p>
                      <p style={{ fontSize: "14px" }}>
                        <strong>Conditions:</strong>{" "}
                        {medicalInfo?.existingMedicalConditions || "-"}
                      </p>
                      <p style={{ fontSize: "14px" }}>
                        <strong>Weight:</strong> {medicalInfo?.weight || "-"} kg
                      </p>
                      <p style={{ fontSize: "14px" }}>
                        <strong>Pulse:</strong> {medicalInfo?.pulse || "-"} bpm
                      </p>
                    </div>
                  </div>
                </div>
                <hr></hr>

                {/* Emergency Contact */}
                <div className="flex items-start gap-3">
                  <svg
                    className="h-5 w-5 text-red-600"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    viewBox="0 0 24 24"
                  >
                    <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
                    <circle cx="12" cy="7" r="4" />
                  </svg>
                  <div className="space-y-1.5">
                    <h3 className="text-base font-semibold text-gray-800 text-decoration-underline">
                      Emergency Contact
                    </h3>
                    <p style={{ fontSize: "14px" }}>
                      <strong>Name:</strong>{" "}
                      {basicInfo?.emergencycontactname || "-"}
                    </p>
                    <p style={{ fontSize: "14px" }}>
                      <strong>Relationship:</strong>{" "}
                      {basicInfo?.relationtopatient || "-"}
                    </p>
                    <p style={{ fontSize: "14px" }}>
                      <strong>Phone:</strong>{" "}
                      {basicInfo?.emergencycontactnumber || "-"}
                    </p>
                  </div>
                </div>
              </div>
              <hr></hr>

              <div className="shrink-0 bg-border h-[1px] w-full"></div>
              <div className="flex justify-between text-sm text-muted-foreground">
                <span>
                  Registered on:{" "}
                  {basicInfo?.insertedDate
                    ? new Date(basicInfo.insertedDate)
                        .toLocaleDateString("en-GB", {
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                        })
                        .replace(/ /g, "-")
                    : "N/A"}
                </span>
                <span>
                  Last Updated:{" "}
                  {basicInfo?.updateddate
                    ? new Date(basicInfo.updateddate)
                        .toLocaleDateString("en-GB", {
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                        })
                        .replace(/ /g, "-")
                    : "N/A"}
                </span>
              </div>
    </div>
          </div>
         

          <div className="flex-1">
            <PatientsDoctorTab
              patientOverviewData={patientOverviewData}
              medicalInfo={medicalInfo}
              basicInfo={basicInfo}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default  PatientsOverview;
